var chars = require('./chars');

module.exports = function reverse(str) {
  return chars(str).reverse().join('');
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore.string/reverse.js
// module id = 810
// module chunks = 0